import { css } from "@emotion/react";
import { Theme, useTheme } from "@mui/material";
import { MouseEventHandler } from "react";

import { fixedHeight, fixedWidth, flexRow } from "~/lib/client/design";

const SingleSelectInput = ({
  label,
  selected,
  setSelected,
}: {
  label: string;
  selected: boolean;
  setSelected: MouseEventHandler;
}) => {
  const theme = useTheme();
  return (
    <div role={"button"} onClick={setSelected} css={rootStyle(theme, selected)}>
      <div css={orderSelectedIconStyle(theme, selected)} />
      {label}
    </div>
  );
};

const rootStyle = (theme: Theme, selected: boolean) => css`
  height: 1.625rem;
  border-radius: 52px;
  border: 1px solid ${theme.palette.divider};
  background: ${selected
    ? theme.palette.background.default
    : theme.palette.background.paper};
  ${flexRow};
  padding: 0 1rem 0 6px;
  gap: 0.25rem;
  font-size: 0.75rem;
  line-height: 0.75rem;
  align-items: center;
  flex-shrink: 0;

  &:hover {
    cursor: pointer;
  }
`;

const orderSelectedIconStyle = (theme: Theme, selected: boolean) => css`
  ${fixedWidth("0.75rem")}
  ${fixedHeight("0.75rem")}
  background: ${selected ? theme.palette.primary.main : "none"};
  border: 1px solid ${theme.palette.divider};
  border-radius: 50%;
`;

export default SingleSelectInput;
